import authSlice, { authActions } from './model/slice/authDataSlice'
import {
    getAcceptedMoments,
    getActivityError,
    getActivityPending,
    getAllCards,
    getArrayCard,
    getCards,
    getDirection,
    getError,
    getIsLoaded,
    getRejectedMoments,
    getStatus,
    getUid,
    getWantedMoments,
} from './model/selectors/getSelectors'

export {
    acceptMoment,
    addMomentPin,
    cycleMoment,
    moveMomentToAccepted,
    moveMomentToRejected,
    moveMomentToWanted,
    rejectMoment,
    removeMomentPin,
    toggleMoment,
    wantMoment,
} from './model/services/updateActivity'

export {
    authActions,
    getAcceptedMoments,
    getActivityError,
    getActivityPending,
    getAllCards,
    getArrayCard,
    getCards,
    getDirection,
    getError,
    getIsLoaded,
    getRejectedMoments,
    getStatus,
    getUid,
    getWantedMoments,
}

export default authSlice
